export var BAR_WIDTH = 50;
export var calculateBarProperties = function (_a) {
    var xMin = _a.xMin, xMax = _a.xMax, x = _a.x, y = _a.y, margins = _a.margins, svgDimensions = _a.svgDimensions;
    var height = svgDimensions.height - margins.top - margins.bottom;
    var width = BAR_WIDTH;
    var barX = x - BAR_WIDTH / 2;
    if (xMax === x || xMin === x)
        width = BAR_WIDTH / 2;
    if (xMin === x)
        barX = xMin;
    var rightEdge = x + BAR_WIDTH / 2;
    var leftEdge = barX - xMin;
    if (rightEdge > xMax)
        width = BAR_WIDTH - (rightEdge - xMax);
    if (leftEdge < 0) {
        width = BAR_WIDTH + leftEdge;
        barX = barX - leftEdge;
    }
    var barY = y || margins.top;
    return {
        height: height,
        width: width,
        barX: barX,
        barY: barY,
    };
};
